import { Component, inject } from '@angular/core';
import { SignalREventService } from '../../common/services/signalR.service';
import { BaseViewComponent } from '../base-view.component';
import { PinResponse } from '../../common/services/securedata.sevice';
import { StateChangedModel } from '../../common/services/state.service';


@Component({
    selector: 'app-pin-view',
    templateUrl: './pin-view.component.html',
    styleUrl: './pin-view.component.scss',
    standalone: false
})
export class PinViewComponent extends BaseViewComponent {
  #signalREventService = inject(SignalREventService);
  pin: string = '';

  protected override refreshView(): void {

  }

  protected override onSecureDataChanged(val: StateChangedModel): void {
    if (val.Type == 'Start') {
      const pinData = val.Data as PinResponse;
      if (pinData) {
        this.pin = pinData.Pin;
      }
    }
  }
}
